import { ScenarioDetailBase } from './base/scenario-detail-base';

export class ScenarioDetail extends ScenarioDetailBase { }